import { useState, useEffect } from "react";
import { sound } from "@/lib/sound";

const NODES = [
  { i: 0, x: 50, y: 12 },
  { i: 1, x: 85, y: 40 },
  { i: 2, x: 70, y: 85 },
  { i: 3, x: 30, y: 85 },
  { i: 4, x: 15, y: 40 },
];
const LIMIT = 8;

export default function SpellCasting({ world, onWin }) {
  const [next, setNext] = useState(0);
  const [time, setTime] = useState(LIMIT);

  useEffect(() => {
    if (next >= NODES.length) return;
    const id = setInterval(() => {
      setTime((t) => {
        if (t <= 0.1) {
          sound.playError();
          setNext(0);
          return LIMIT;
        }
        return +(t - 0.1).toFixed(1);
      });
    }, 100);
    return () => clearInterval(id);
  }, [next]);

  const click = (i) => {
    if (i === next) {
      const nn = next + 1;
      setNext(nn);
      sound.playClick();
      if (nn >= NODES.length) {
        sound.playGift();
        onWin();
      }
    } else {
      sound.playError();
      setNext(0);
    }
  };

  const done = NODES.filter((n) => n.i < next);
  const pts = done.map((n) => `${n.x},${n.y}`).join(" ");

  return (
    <div className="text-center">
      <p className="text-sm text-white/70">Trace the rune — tap the glowing nodes in order before time runs out.</p>
      <div className="relative mx-auto mt-5 h-64 w-64">
        <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
          {pts && (
            <polyline
              points={pts}
              fill="none"
              stroke={world.accent}
              strokeWidth="1.5"
              strokeLinecap="round"
              style={{ filter: `drop-shadow(0 0 4px ${world.accent})` }}
            />
          )}
        </svg>
        {NODES.map((n) => {
          const reached = n.i < next;
          const isNext = n.i === next;
          return (
            <button
              key={n.i}
              onClick={() => click(n.i)}
              data-testid={`rune-node-${n.i}`}
              className="absolute flex h-9 w-9 items-center justify-center rounded-full border-2 font-display text-xs transition-all"
              style={{
                left: `${n.x}%`,
                top: `${n.y}%`,
                transform: `translate(-50%, -50%) scale(${isNext ? 1.15 : 1})`,
                borderColor: world.accent,
                background: reached ? world.accent : "rgba(0,0,0,0.6)",
                color: reached ? "#000" : "#fff",
                boxShadow: isNext ? `0 0 18px ${world.accent}` : "none",
              }}
            >
              {n.i + 1}
            </button>
          );
        })}
      </div>
      <div className="mx-auto mt-3 h-1.5 w-48 overflow-hidden rounded-full bg-white/10">
        <div
          className="h-full rounded-full"
          style={{ width: `${(time / LIMIT) * 100}%`, background: world.accent }}
        />
      </div>
      <p className="mt-2 text-xs text-white/45">
        {next}/{NODES.length} traced · {time.toFixed(1)}s
      </p>
    </div>
  );
}
